import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const encode = (data) =>
  Object.keys(data)
    .filter((k) => data[k] !== undefined && data[k] !== null)
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(
      Array.isArray(data[k]) ? data[k].join(", ") : String(data[k])
    ))
    .join("&");

// Submit form to Netlify (works after deploying to Netlify with hidden form registered in index.html).
// Netlify captures POSTs to "/" with url-encoded body and a matching form-name.
export async function submitNetlifyForm(formName, payload) {
  return fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: encode({ "form-name": formName, ...payload }),
  });
}

// Legacy backend endpoint (used only when hosted alongside the FastAPI backend).
export async function postLead(payload) {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
}
